import React from 'react';
import { InstructionFormDetails } from '../../commonAfterFormPage/InstructionFormDetails';
import { NormalText } from '../../Styles';

export const hsbcPaymentInstructionsLines: InstructionFormDetails['paymentInstructionsLines'] = [
  {
    description: 'supplierValidation.afterRegister.beneficiaryName',
    value: 'nsKnox Technologies UK LTD',
  },
  {
    description: 'supplierValidation.afterRegister.address',
    value: '4th Floor, St. James House, St. James Square, Cheltenham, GL50 3PR',
  },
  { description: 'supplierValidation.afterRegister.checkingAccount', value: '99408297' },
  { description: 'supplierValidation.afterRegister.swift', value: 'HBUKGB4B' },
  { description: 'supplierValidation.afterRegister.iban', value: 'GB30HBUK40127799408297' },
];

export const hsbcPaymentInstructionsAddress: InstructionFormDetails['paymentInstructionsAddress'] = {
  description: 'supplierValidation.afterRegister.bankAndAddress',
  value: (
    <NormalText>
      HSBC Innovation Bank Limited, Alphabeta,
      <br />
      14-18 Finsbury Square, London, EC2A 1BR, United Kingdom
    </NormalText>
  ),
};
